import axios from '@/axios'
import router from '@/router'


let accessToken = localStorage.accessToken
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
axios.defaults.headers.post['Content-Type'] = 'application/json'


export default{
	namespaced: true,
	state: {
		setupIntent: null,
	},
	actions: {
		async getSetupIntent ({ commit }, payload){
			await axios.post('/card/init_save_card', payload)
			
				.then((res) => {
					commit('SET_SETUP_INTENT', res.data.data.client_secret)
				})
				.catch((err) => { console.log(err)})
		},
		async getPublicSetupIntent ({ commit }, payload){
			await axios.post('/card/public_init_save_card', payload)
			
				.then((res) => {
					commit('SET_SETUP_INTENT', res.data.data.client_secret)
				})
				.catch((err) => { console.log(err)})
		},
		async insertPaymentCard ({ rootState, commit }, callback_payload) {
			return new Promise((resolve, reject) => { 
				axios.post('/card/callback_save_card', callback_payload)
				.then(() => {
					if(rootState.user.onboard_step === 6){
						resolve(payload)
					}else {
						let current_step = 5
						axios.patch(`/user/${rootState.user.id}`, { onboard_step: current_step })
						.then(() => {
							let payload = {
								onboard_step: current_step,
								...rootState.user
							}
							commit('user/UPDATE_USER_INFO', payload,{root:true})
							resolve(payload)
						}).catch((err) => {reject(err)})
					}
				}).catch((err) => { reject(err)})
			})		
		},
		async testpayment ({ commit }, payload){
			if(process.env.NODE_ENV !== 'production'){
				console.log('yeahh development');

				await axios.post('/stripe/testpay', payload)
					.then((res) => {
						console.log(res.data.data.client_secret)
					})
					.catch((err) => { console.log(err)})
			}else{
				console.log('You are not authorized to perform this action.');
			}
		},
		async testcheckout ({ commit }){
			if(process.env.NODE_ENV !== 'production'){
				console.log('yeahh development');
				return await axios.post('/stripe/testcheckout')
				.then((res) => {
					return res.data.data;
				})
				.catch((err) => {reject(err)})
			}else{
				console.log('You are not authorized to perform this action.');
			}
		},
		async ordercheckout ({ commit }){
			if(process.env.NODE_ENV !== 'production'){
				console.log('yeahh development');

				let order_id=router.currentRoute.params.orderid;

				return await axios.post('/stripe/ordercheckout/'+order_id)
				.then((res) => {
					return res.data.data;
				})
				.catch((err) => {reject(err)})
			}else{
				console.log('You are not authorized to perform this action.');
			}
		},

	},
	mutations: {
		SET_SETUP_INTENT(state, setupIntent){
			state.setupIntent = setupIntent
		}
	},
	getters: {

	}
}